import { render } from "./Hillwood.vue?vue&type=template&id=457cd024&scoped=true"
import script from "./Hillwood.vue?vue&type=script&lang=js"
export * from "./Hillwood.vue?vue&type=script&lang=js"

import "./Hillwood.vue?vue&type=style&index=0&id=457cd024&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457cd024"]])

export default __exports__